import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

export default (customer, cb) => Vue.$http
  .patch(`Customers/${encodePathSegment(customer.id)}`, customer)
      .then((response) => {
        cb(null, response);
      })
      .catch((error) => {
        cb(error);
      });



// WEBPACK FOOTER //
// ./src/services/customer/edit.js